import {SystemRenderer} from "pixi.js";

export class Utils {
    public static convertToSequenceString(num: number, sequenceDigitsCount: number = 2) {
        let sequenceString = num.toString();
        for (let i = sequenceString.length; i < sequenceDigitsCount; i++) {
            sequenceString = "0".concat(sequenceString);

        }
        return sequenceString;
    }

    public static formatMoney(num: number, denom: number, formatCurrency: Boolean = false, noCoins: boolean = false, separator: String = ' ', doNotSetZeroAsCredit: Boolean = false) {
        const creditValue = Math.floor(num / denom).toString()
        const creditStr = doNotSetZeroAsCredit && creditValue === '0' ? '1' : creditValue

        let str: string = formatCurrency ? (num / 100).toFixed(noCoins ? 0 : 2) : creditStr;

        let arr: Array<any> = str.split(".");
        let n: String = arr[0];
        let prefix: Array<any> = n.split('');

        if (formatCurrency) {
            var counter: number = 3;
            var i: number = prefix.length;
            while (--i > 0) {
                counter--;
                if (counter == 0) {
                    counter = 3;
                    prefix.splice(i, 0, separator);
                }
            }
        }

        if (arr[1])
            return (prefix.join('') + "." + arr[1]);
        else
            return (prefix.join(''));
    }

    /**
     * Returns a random number in the range rangeStart(inclusive) - rangeEnd(exclusive)
     * @param {number} rangeStart - the start of the range (this number can be returned as a result
     * @param {number} rangeEnd - the end of the range (this number will never be returned as a result
     * @example
     * Utils.randomNumberInRange(4, 20) -> returns a number in the range [4, 20)
     *
     * If rangeStart is greater than rangeEnd the exclusivity of the range is swapped
     * Utils.randomNumberInRange(20, 4) -> returns a number in the range (4, 20]
     *
     * It also works with negative numbers
     * Utils.randomNumberInRange(-20, -4) -> returns a number in the range [-20, -4)
     * Utils.randomNumberInRange(-4, -20) -> returns a number in the range (-20, -4]
     */
    public static randomNumberInRange(rangeStart: number, rangeEnd: number) {
        return rangeStart + Math.random() * (rangeEnd - rangeStart);
    }

    public static getResolutionSuffix(): string {
        const renderer: PIXI.SystemRenderer = (PIXI as any).renderer
        return renderer.resolution != 1 ? `@${renderer.resolution}x` : ''
    }
}
